import { type PropsWithChildren, type ReactNode } from 'react';

import WidgetError from '@/components/errors/WidgetError';
import { cn } from '@/lib/utils';

type Props = {
  error: Error | null;
};

const DonutContainer = ({ error, children, ...rest }: PropsWithChildren<Props>) => {
  return (
    <div {...rest} className={cn('flex flex-1 flex-wrap items-center justify-evenly')}>
      {error ? <WidgetError /> : children}
    </div>
  );
};

type ItemProps = {
  minWidth: number;
  height: number;
  caption?: ReactNode;
};

DonutContainer.Item = ({
  minWidth,
  height,
  caption,
  children,
  ...rest
}: PropsWithChildren<ItemProps>) => {
  return (
    <div {...rest} className={cn('flex flex-col')} style={{ minWidth, height }}>
      {children}
      {caption && <div className={cn('flex flex-col items-center px-3 pb-3')}>{caption}</div>}
    </div>
  );
};

export default DonutContainer;
